import styled from 'styled-components';
import { ListReference } from 'modules/legacySegmentation/domain';
import { Link } from 'ui/links';
import { colors, fontSizes, letterSpacing } from 'ui/theme';
import { Cell } from './table/Cell';
import { TABLE_COLUMNS } from './constants';
import { getListReferenceUrl } from './utils';

type ListReferenceNameCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const StyledCell = styled(Cell)`
  && {
    width: 100%;
  }
`;

const StyledLabel = styled(Link)`
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledId = styled.div`
  font-size: ${fontSizes.s12};
  letter-spacing: ${letterSpacing.pos10};
  color: ${colors.textSecondary};
`;

export const testIds = {
  cell: 'segmentation-lrnc-cell',
};

export const ListReferenceNameCell = ({ listReference, rowIndex }: ListReferenceNameCellProps) => (
  <StyledCell
    data-test={testIds.cell}
    columnId={TABLE_COLUMNS.NAME}
    {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
  >
    <StyledLabel href={getListReferenceUrl(listReference)} target="_blank">
      {listReference.name}
    </StyledLabel>
    <StyledId>{`ID: ${listReference.id}`}</StyledId>
  </StyledCell>
);
